import Layout from '@layout/Index'

export const middleEndTask = [
  {
    path: '/middle-end-task',
    component: Layout,
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "market-table" */ './pages/MiddleEndTaskForm'),
        name: '添加中台任务',
        meta: {
          title: '添加中台任务',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "task-form" */ './pages/MiddleEndTaskForm.vue'),
        name: '修改中台任务',
        meta: {
          title: '修改中台任务',
        },
      },
      {
        path: 'audit/table',
        component: () => import(/* webpackChunkName: "market-table" */ './pages/MiddleEndTaskAudit'),
        name: '任务审批',
        meta: {
          title: '任务审批',
        },
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/middle-end-task/middle-end-task.route.js